import React, { createContext, useContext, useState, useCallback } from 'react';
import AlertModal from 'components/modals/AlertModal';
import AlertGracias from 'components/modals/AlertGracias';


let globalShowAlert = null;
const AlertContext = createContext();


export const useAlert = () => useContext(AlertContext);

export const showGlobalAlert = (title, text, gracias = null) => {
  if (globalShowAlert) globalShowAlert(title, text, gracias);
};

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({ visible: false, title: '', text: '', gracias: null });

  const showAlert = useCallback((title, text, gracias = null) => {
    setAlert({ visible: true, title, text, gracias });
  }, []);

  const hideAlert = useCallback(() => {
    setAlert({ ...alert, visible: false });
  }, [alert]);

  globalShowAlert = showAlert;

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert.visible && (
        alert.gracias ? (
          <AlertGracias onClose={hideAlert} />
        ) : (
          <AlertModal title={alert.title} text={alert.text} onClose={hideAlert} />
        )
      )}
    </AlertContext.Provider>
  );
};
